<template>
    <div class="modal fade offline-modal" tabindex="-1" role="dialog" id="offline-modal" aria-labelledby="offline-modal"
         aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-icon"><i class="fas fa-satellite-dish"></i></div>
                    <h2 class="modal-title">Connection Lost</h2>
                    <p class="modal-description">Please check your internet connection and refresh the page. If the
                        problem persists, please contact administrator.</p>
                    <button class="refresh-button" @click="refresh()">Refresh</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';

    export default {
        name: "forward-calculation-modal",
        data() {
            return {
                //
            };
        },
        mounted() {
            this.openModal();
        },
        destroyed() {
            this.closeModal();
        },
        methods: {
            openModal() {
                $("#offline-modal").modal("show");
            },
            closeModal() {
                $("#offline-modal").modal("hide");
            },
            refresh() {
                location.reload();
            }
        }
    }
</script>

<style lang="scss" scoped>
    #offline-modal {
        .modal-content {
            border: none;

            .modal-header {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 10px 10px 0 10px;
                border: none;

                .close-btn {
                    font-size: 20px;
                    color: $dark-gray;
                    background: none;
                    cursor: pointer;
                    @include removeBootstrapOutline;
                    @include fastestTransition;

                    &:hover {
                        color: $darker-gray;
                    }
                }
            }

            .modal-body {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding: 30px 50px;

                .modal-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 128px;
                    height: 128px;
                    background-color: $lightest-gray;
                    color: $dark-gray;
                    font-size: 60px;
                    border-radius: 50%;
                    margin: 0 0 20px 0;
                }

                .modal-title {
                    margin: 0 0 10px 0;
                    font-family: $lato;
                    font-size: 16px;
                    font-weight: 700;
                    color: $text-color;
                    text-align: center;
                }

                .modal-description {
                    width: 80%;
                    margin: 0 0 30px 0;
                    font-family: $lato;
                    font-weight: normal;
                    font-size: 14px;
                    text-align: center;
                    color: $dark-gray;
                }

                .refresh-button {
                    display: block;
                    padding: 10px 50px;
                    border-radius: 25px;
                    font-family: $montserrat;
                    font-weight: bold;
                    font-size: 14px;
                    text-transform: uppercase;
                    background-color: $dark-gray;
                    color: $white;
                    cursor: pointer;
                    @include removeBootstrapOutline;
                    @include fastestTransition;

                    i {
                        margin: 0 10px 0 0;
                    }

                    &:hover {
                        background-color: $teal;
                    }

                    &:disabled {
                        background-color: $gray;
                        cursor: default;

                        &:hover {
                            background-color: $gray;
                        }
                    }
                }
            }
        }

        @media screen and (max-width: $breakpoint-sm) {
            .modal-content {
                .modal-header {
                    .close-btn {
                        font-size: 15px;
                    }
                }

                .modal-body {
                    padding: 0 15px 25px 15px;

                    .modal-icon {
                        width: 64px;
                        height: 64px;
                        font-size: 30px;
                        margin: 0 0 10px 0;
                    }

                    .modal-title {
                        width: 100%;
                        font-size: 14px;
                        margin: 0 0 10px 0;
                    }

                    .modal-description {
                        font-size: 13px;
                        width: 90%;
                        margin: 0 0 15px 0;
                    }

                    .refresh-button {
                        padding: 7px 50px;
                    }
                }
            }
        }
        @media screen and (min-width: $breakpoint-sm) {
            .modal-content {
                .modal-body {
                    .user-search-form {
                        width: 100%;
                    }
                }
            }
        }
        @media screen and (min-width: $breakpoint-md) {
            .modal-content {
                .modal-body {
                    .user-search-form {
                        width: 90%;
                    }
                }
            }
        }
        @media screen and (min-width: $breakpoint-lg) {
            .modal-content {
                .modal-body {
                    .user-search-form {
                        width: 60%;
                    }
                }
            }
        }
    }

    .dark {
        #offline-modal {
            .modal-content {
                background-color: $extra-dark-gray;

                .modal-body {
                    .modal-icon {
                        background-color: $extra-darker-gray;
                        color: $gray;
                    }

                    .modal-title {
                        color: $gray;
                    }

                    .modal-description {
                        color: $dark-gray;
                    }

                    .refresh-button {
                        background-color: $extra-darker-gray;
                        color: $white;

                        &:hover {
                            background-color: $teal;
                        }

                        &:disabled {
                            background-color: $darkest-gray;

                            &:hover {
                                background-color: $darkest-gray;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
